import React from "react";
import {useNavigate} from "react-router-dom";
import aispFigure from "/assets/aisp-figure.svg?url"
import HeaderItem from "../../components/headerItem/HeaderItem";
import FeatureKey from "../../components/featureKey/FeatureKey";
import {FeatureContainer, FeatureGrid, FeatureKeyTitle} from "../../components/featureKey/FeatureKey.css";
import cardLogo from "/assets/api-card-logo.svg?url";
import StoreItem from "../../components/storeItem/StoreItem";
import {Recommended, SeeAlsoText} from "../../global.css";
import oauth2Logo from "/assets/api-oauth2-logo.svg?url"
import {UseCaseContainer, UseCaseIntro, UseCaseTitle} from "../../components/UseCaseItem/UseCaseItem.css";
import UseCaseItem from "../../components/UseCaseItem/UseCaseItem";
import ScrollToTop from "../../hooks/scrollToTop";

function Aisp() {
    const navigate = useNavigate()
    return (
        <div>
            <HeaderItem title={"AISP"}
                        description={"L'API AISP (Account Information Service Provider) est une interface de programmation d'application qui permet à des tiers, tels que des agrégateurs financiers ou des applications de gestion financière, d'accéder aux informations de compte d'un utilisateur avec son consentement."}
                        imageUrl={aispFigure}
                        onClick={() => navigate("/aisp/documentation")}>
            </HeaderItem>

            <div className={FeatureKeyTitle}>Fonctionnalités Clés</div>

            <div className={FeatureContainer}>
                <div className={FeatureGrid}>
                    <FeatureKey title={"1"} description1={"Accès aux informations"} description2={"de comptes"}></FeatureKey>
                    <FeatureKey title={"2"} description1={"Consentement"} description2={"utilisateur"}></FeatureKey>
                    <FeatureKey title={"3"} description1={"Agrégation"} description2={"de comptes"}></FeatureKey>
                    <FeatureKey title={"4"} description1={"Analyse"} description2={"des transactions"}></FeatureKey>
                    <FeatureKey title={"5"} description1={"Personnalisation"} description2={"des offres"}></FeatureKey>
                    <FeatureKey title={"6"} description1={"Conformité"} description2={"réglementaire"}></FeatureKey>
                    <FeatureKey title={"7"} description1={"Notifications"} description2={"et Alertes"}></FeatureKey>
                </div>
                <div className={UseCaseContainer}>
                    <div className={UseCaseTitle}>Cas d'utilisation</div>
                    <p className={UseCaseIntro}>
                        Les fournisseurs de services financiers tiers peuvent l'utiliser pour faciliter les paiements en ligne de manière sécurisée et pratique.
                        <br/>
                        Voici quelques-uns des cas d'utilisation courants de l'API PISP :
                    </p>
                    <UseCaseItem
                        number="1"
                        title="Paiements en Ligne :"
                        description="Les fournisseurs de services de paiement tiers peuvent utiliser l'API PISP pour permettre aux utilisateurs d'effectuer des paiements en ligne directement à partir de leur compte bancaire. Cela offre une alternative pratique aux méthodes traditionnelles de paiement par carte de crédit ou de débit, en éliminant la nécessité de saisir manuellement les détails de la carte."
                    />
                    <UseCaseItem
                        number="2"
                        title="Transferts d'Argent entre Utilisateurs :"
                        description="Les applications de transfert d'argent peer-to-peer (P2P) peuvent intégrer l'API PISP pour permettre aux utilisateurs d'envoyer de l'argent à d'autres personnes en utilisant simplement leur compte bancaire. Cela simplifie le processus de transfert d'argent et peut offrir des frais plus bas par rapport aux services de transfert d'argent traditionnels."
                    />
                    <UseCaseItem
                        number="3"
                        title="Paiements Récurrents :"
                        description="Les fournisseurs de services d'abonnement, les plateformes de streaming, les services de cloud, etc., peuvent utiliser l'API PISP pour permettre aux utilisateurs d'effectuer des paiements récurrents automatiques à partir de leur compte bancaire. Cela garantit le paiement régulier des abonnements et des services sans interruption."
                    />
                    <UseCaseItem
                        number="4"
                        title="Facturation en Temps Réel :"
                        description="Les entreprises peuvent utiliser l'API PISP pour permettre à leurs clients de payer leurs factures en temps réel directement à partir de leur compte bancaire. Cela peut inclure des paiements de factures d'électricité, de services publics, de services de télécommunications, etc."
                    />
                    <UseCaseItem
                        number="5"
                        title="Paiements Instantanés :"
                        description="L'API PISP peut être utilisée pour faciliter les paiements instantanés entre entreprises et consommateurs, ou entre entreprises. Cela peut être particulièrement utile dans le cadre de paiements d'urgence, de remboursements rapides, ou de transactions commerciales nécessitant un règlement immédiat."
                    />
                    <UseCaseItem
                        number="6"
                        title="Intégration dans des Applications Financières :"
                        description="Les applications de gestion financière, les agrégateurs de comptes bancaires, les applications de budgétisation, etc., peuvent intégrer l'API PISP pour permettre aux utilisateurs d'effectuer des paiements et d'accéder à leurs informations de compte bancaire à partir d'une seule application."
                    />
                </div>
                <div className={SeeAlsoText}>Nous vous recommandons aussi....</div>
                <div className={Recommended}>
                    <StoreItem
                        title={"PISP"}
                        description={"Prestataires de services d’initiation de paiement"}
                        onClick={() => navigate("/pisp")}
                        imageUrl={cardLogo}>
                    </StoreItem>
                    <StoreItem
                        title={"OAuth2"}
                        description={"Protocole d'autorisation à accès limité aux ressources utilisateur"}
                        onClick={() =>navigate("/oauth2")}
                        imageUrl={oauth2Logo}>
                    </StoreItem>
                </div>

            </div>
            <ScrollToTop />
        </div>


    )
        ;
}

export default Aisp;